import { useRef } from 'react';

import { useRuntime } from '@xing-com/crate-xinglet/internal';
import { registerExperiment } from '@xing-com/splitkit';

import { getGlobalRegisteredExperiments } from './registered-experiments';

export const useRegisterExperiments = (): void => {
  const runtime = useRuntime();
  const registered = useRef(false);

  if (registered.current) return;

  const globalRegisteredExperiments = getGlobalRegisteredExperiments(
    runtime.metadataMap
  );

  for (const {
    name,
    supportedVariants,
    experimentType,
  } of globalRegisteredExperiments) {
    registerExperiment(name, supportedVariants, experimentType);
  }

  registered.current = true;
};
